import React from 'react'
import CatalogSubNavigation from '@Components/Navigations/RightsholderSubNavigation/CatalogSubNavigation'
import MatchingToolSubNavigation from '@Components/Navigations/RightsholderSubNavigation/MatchingToolSubNavigation'
import MemberSettingsSubNavigation from '@Components/Navigations/RightsholderSubNavigation/MemberSettingsSubNavigation'
import SummarySubNavigation from '@Components/Navigations/RightsholderSubNavigation/SummarySubNavigation'
import Sidebar from '@Components/Navigations/Sidebar'
import WorksRegistrationSubNavigation from '@Components/Navigations/RightsholderSubNavigation/WorksRegistrationSubNavigation'
import RoyaltiesSubNavigation from '@Components/Navigations/RightsholderSubNavigation/RoyaltiesSubNavigation'

const RightsholderSubNavigation = () => (
    <Sidebar>
        <SummarySubNavigation />
        <CatalogSubNavigation />
        <WorksRegistrationSubNavigation />
        <MatchingToolSubNavigation />
        <RoyaltiesSubNavigation />
        <MemberSettingsSubNavigation />
    </Sidebar>
)

export default RightsholderSubNavigation
